import React, { useCallback, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import OfferBanner from "./OfferBanner";
import { fetchActiveOffers } from "../../lib/offers/offerApi";

// Gives the server a moment past endAt before asking again, so the re-fetch
// does not race the offer's own end time.
const EXPIRY_REFETCH_DELAY_MS = 2000;

// Home screen banner for the highest priority live offer. Renders nothing when
// no offer is live or the offers API fails.
const HomeOfferBanner = ({ className = "" }) => {
  const navigate = useNavigate();
  const userId = Cookies.get("userId");
  const token = Cookies.get("token");
  const [state, setState] = useState({ offers: [], clockOffsetMs: 0 });
  const refetchTimer = useRef(null);

  const loadOffers = useCallback(async () => {
    if (!userId) return;
    try {
      setState(await fetchActiveOffers({ userId, token }));
    } catch {
      setState({ offers: [], clockOffsetMs: 0 });
    }
  }, [userId, token]);

  useEffect(() => {
    loadOffers();
    return () => window.clearTimeout(refetchTimer.current);
  }, [loadOffers]);

  const handleExpire = useCallback(() => {
    window.clearTimeout(refetchTimer.current);
    refetchTimer.current = window.setTimeout(loadOffers, EXPIRY_REFETCH_DELAY_MS);
  }, [loadOffers]);

  const offer = state.offers[0];
  if (!offer) return null;

  return (
    <OfferBanner
      key={`${offer.slug}-${offer.endAt}`}
      offer={offer}
      clockOffsetMs={state.clockOffsetMs}
      dismissible
      onCta={() => navigate("/subscription")}
      onExpire={handleExpire}
      className={className}
    />
  );
};

export default HomeOfferBanner;
